import { render, staticRenderFns } from "./ShowSku.vue?vue&type=template&id=35e797a5"
import script from "./ShowSku.vue?vue&type=script&lang=js"
export * from "./ShowSku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports